export default {
  '上级机构名称':'Name of the superior organization',
  '本机构名称':'Name of this organization',
  '机构代码':'Organization code',
  '管理员名称':'Administrator name',
  '管理员账号':'Administrator account',
  '设备激活码':'Device activation code',
  '学制':'Educational system',
  '编辑机构信息':'Edit organization information',
  '机构名称':'Organization name',
  '机构类型':'Organization type',
  '地图选择':'Map selection',
  '经纬度':'Latitude and longitude',
  '密码':'Password',
  '选择地点':'Select a location',
  '关键词搜索':'Keyword search',
  '请选择位置':'Please select a location',
  '全国':'Nationwide',
  '地址：':'Address:',
  '区域':'Area',
  '上级机构':'Superior organization',
  '机构通用管理密码':'Institutional Universal Administrative Password',
  '设备部分功能的调试密码，非管理员账号的密码':'Debug Password for Partial Device Functions and Non-Admin Account Password',
}    